import type { Vehicle } from '@cobliteam/common-types';

import { ReactComponent as CarIcon } from '@cobliteam/ui-business/icons/filters/directions_car_cb.svg';

import Button from '@cobliteam/ui/components/Button';

interface VehicleItemProps {
  selectedVehicles: Vehicle[];
  title?: string;
  size?: 'condensed' | 'regular';
  disabled?: boolean;
}

const VehicleTitle = ({ selectedVehicles, title, size, disabled }: VehicleItemProps) => {
  return (
    <Button disabled={disabled} type='button' size={size} variant='text' startIcon={<CarIcon className='h-4 w-4' />}>
      {title || <>Veículos {selectedVehicles?.length > 0 ? `(${selectedVehicles?.length})` : ''}</>}
    </Button>
  );
};

export default VehicleTitle;
